import { Injectable } from '@angular/core';

import { HttpService, NotificationService, TmsWebBaseEditService } from 'tms-lib';
import { ProductCushionSpec } from '../../../models';

@Injectable({
  providedIn: 'root',
})
export class ProductCushionSpecService extends TmsWebBaseEditService<ProductCushionSpec, ProductCushionSpec> {
  constructor(protected httpService: HttpService, protected notificationService: NotificationService) {
    super('CushionSpec', $localize`Cushion Spec`, httpService, notificationService);
  }
}
